/* global Swiper, Plyr, $, jQuery */
/* eslint-disable no-unused-expressions, no-sequences, no-unused-vars */
'use strict'
const debouncer = (e, t) => {
    let i = null
    return (...n) => {
      window.clearTimeout(i),
        (i = window.setTimeout(() => {
          e.apply(null, n)
        }, t))
    }
  },
  selectors = {
    productImagesThumbnailsSlider: '.pdp__images__thumbnails__slider',
    productImagesMainSlider: '.pdp__images__main-slider',
    upsellsSlider: '.pdp__info__upsells__content__slider',
    buildYourRoutineSlider: '.pdp__build-your-routine__content__slider',
    tipsAndTricksSlider: '.pdp__tips-tricks__content__slider',
    similarProductsSlider: '.pdp__similar-products__content__slider',
    shopVideoSlider: '.pdp__shop-video__content__slider',
    shopVideoSliderSlide: '.pdp__shop-video__content__slider__wrapper__slide',
    shopVideoSliderSlideActive:
      '.pdp__shop-video__content__slider__wrapper__slide--active',
    variantRadiosContainer: '.pdp__info__variant-radios',
    purchaseTypeInput: 'input[name="purchase-type"]',
    rechargeVariantMap: '#recharge-variant-map',
    thumbnailItem: '.pdp__images__thumbnails__slider__wrapper__item',
    oneTimePrice: '.purchase-type-one-time-price',
    recurringPrice: '.purchase-type-recurring-price',
    variantSelectContainer: '.product-form__input--dropdown',
    pdpInfoPrice: '.pdp__info__price',
  },
  ProductPrice = () => {
    const e = document.querySelector(selectors.variantRadiosContainer)
    if (e) {
      const t = e.querySelectorAll('input[type="radio"]')
      if (!t.length) return

      function i() {
        let t = document.querySelector(selectors.oneTimePrice),
          i = document.querySelector(selectors.recurringPrice),
          n = document.querySelector(selectors.pdpInfoPrice)
        t &&
          (this.dataset.defaultPrice &&
          this.dataset.compareAtPrice !== this.dataset.defaultPrice
            ? (t.innerHTML = `${this.dataset.defaultPrice}<span> ${this.dataset.compareAtPrice}</span>`)
            : (t.innerText = this.dataset.defaultPrice)),
          n &&
            (this.dataset.defaultPrice &&
            this.dataset.compareAtPrice !== this.dataset.defaultPrice
              ? (n.innerHTML = `${this.dataset.defaultPrice}<span> ${this.dataset.compareAtPrice}</span>`)
              : (n.innerText = this.dataset.defaultPrice)),
          i && (i.innerText = this.dataset.rechargePrice)
        const r = e.querySelector('.form__label')
        r && (r.textContent = this.value),
          document.querySelector('span.variant-price') &&
            (document.querySelector('span.variant-price').textContent =
              this.dataset.defaultPriceRounded)

        if (
          this.dataset.defaultPrice &&
          this.dataset.compareAtPrice !== this.dataset.defaultPrice
        ) {
          $('.pdp__info__pricex').html(
            this.dataset.defaultPriceRounded +
              '&nbsp;<span>' +
              this.dataset.compareAtPrice +
              '</span>',
          )
        } else {
          $('.pdp__info__pricex').html(this.dataset.defaultPriceRounded)
        }
      }
      for (let e = 0; e < t.length; e++) {
        t[e].addEventListener('change', i)
      }
      t[0].dispatchEvent(new Event('change'))
    }
  },
  thumbnailsSlider = new Swiper(selectors.productImagesThumbnailsSlider, {
        a11y: { wrapperLiveRegion: false },
    slidesPerView: 'auto',
    direction: 'horizontal',
    spaceBetween: 8,
    slideToClickedSlide: !0,
    navigation: {
      nextEl: '.pdp__images__thumbnails__next',
      prevEl: '.pdp__images__thumbnails__prev',
    },
    breakpoints: {
      1024: {
        slidesPerView: 5,
        direction: 'vertical',
        spaceBetween: 8,
        navigation: {
          nextEl: '.pdp__images__thumbnails__next',
          prevEl: '.pdp__images__thumbnails__prev',
        },
      },
    },
  }),
  mainSlider = new Swiper(selectors.productImagesMainSlider, {
    slidesPerView: 1.3,
    centeredSlides: !0,
    spaceBetween: 8,
    thumbs: {
      swiper: thumbnailsSlider,
    },
    breakpoints: {
      768: {
        slidesPerView: 1,
        spaceBetween: 1,
      },
    },
  }),
  reinitializeImageSlider = (e) => {
    let t = '',
      i = ''
    for (let n = 0; n < e.length; n++)
      (t += `\n      <div class="pdp__images__main-slider__wrapper__item swiper-slide">\n        <img src="${e[n].cloudinary_src}w_1350" alt="${e[n].alt}" loading="eager">\n      </div>\n    `),
        (i += `\n      <div class="pdp__images__thumbnails__slider__wrapper__item swiper-slide">\n        <img src="${e[n].cloudinary_src}w_200" alt="${e[n].alt}" loading="eager">\n      </div>\n    `)
    ;(document.querySelector(
      '.pdp__images__thumbnails__slider__wrapper',
    ).innerHTML = i),
      (document.querySelector('.pdp__images__main-slider__wrapper').innerHTML =
        t),
      document
        .querySelector('.pdp__images__thumbnails__prev')
        .classList.add('hide'),
      document
        .querySelector('.pdp__images__thumbnails__next')
        .classList.add('hide'),
      (document.querySelector('.pdp__images__thumbnails__prev').style.display =
        'none'),
      (document.querySelector('.pdp__images__thumbnails__next').style.display =
        'none'),
      (document.querySelector('.pdp__images__thumbnails').style.padding = 0),
      thumbnailsSlider.update(),
      mainSlider.update(),
      adjustNavArrows(
        document.querySelectorAll(selectors.thumbnailItem).length,
      ),
      thumbnailsSlider.slideTo(0),
      mainSlider.slideTo(0),
      ThumbnailKeyboardNavigation()
  },
  thumbnailSlides = document.querySelectorAll(selectors.thumbnailItem),
  thumbnailsContainer = document.querySelector('.pdp__images__thumbnails'),
  prev = document.querySelector('.pdp__images__thumbnails__prev'),
  next = document.querySelector('.pdp__images__thumbnails__next');
document
  .querySelectorAll('.pdp__images__thumbnails__prev, .pdp__images__thumbnails__next')
  .forEach((control) => control.removeAttribute('aria-controls'))

function adjustNavArrows(e = thumbnailSlides.length) {
  window.innerWidth < 768
    ? ((prev.style.display = 'none'),
      (next.style.display = 'none'),
      (thumbnailsContainer.style.padding = '0 0 0 1.6rem'))
    : (window.innerWidth >= 768 && window.innerWidth < 1024) ||
        (window.innerWidth >= 1024 && e <= 5)
      ? ((prev.style.display = 'none'),
        (next.style.display = 'none'),
        (thumbnailsContainer.style.padding = '0'))
      : (window.innerWidth >= 768 && window.innerWidth < 1024
          ? (thumbnailsContainer.style.padding = '0')
          : window.innerWidth >= 1024
            ? ((thumbnailsContainer.style.padding = '2.4rem 0'),
              prev.classList.remove('hide'),
              next.classList.remove('hide'))
            : (thumbnailsContainer.style.padding = '0 0 0 1.6rem'),
        (prev.style.display = 'flex'),
        (next.style.display = 'flex'))
}
adjustNavArrows()
const debouncedAdjustNavArrows = debouncer(adjustNavArrows, 250)
window.addEventListener('resize', debouncedAdjustNavArrows)
const ProductImagesSection = () => {
    const e = document.querySelector(selectors.variantRadiosContainer),
      t = document.querySelector(selectors.variantSelectContainer)
    if (e) {
      const t = e.querySelectorAll('input[type="radio"]')

      function i() {
        if (
          (!this.dataset.hasVariantImages ||
            'true' !== this.dataset.hasVariantImages) &&
          this.dataset.pos
        ) {
          const e = Array.from(thumbnailSlides).filter(
            (e) => e.dataset.position === this.dataset.pos,
          )[0]
          e &&
            (thumbnailsSlider.slideTo(parseInt(e.dataset.slideIndex) - 1),
            mainSlider.slideTo(parseInt(e.dataset.slideIndex) - 1))
        }
      }
      for (let e = 0; e < t.length; e++) t[e].addEventListener('change', i)
    } else if (t) {
      function e() {
        let e = this.options[this.selectedIndex]
        if (e.dataset.pos) {
          const t = Array.from(thumbnailSlides).filter(
            (t) => t.dataset.position === e.dataset.pos,
          )[0]
          t &&
            (thumbnailsSlider.slideTo(parseInt(t.dataset.slideIndex) - 1),
            mainSlider.slideTo(parseInt(t.dataset.slideIndex) - 1))
        }
      }
      t.querySelector('select').addEventListener('change', e)
    }
  },
  ProductInfoUpsells = () => {
    new Swiper(selectors.upsellsSlider, {
      slidesPerView: 1.1,
      spaceBetween: 8,
      centeredSlides: !0,
      pagination: {
        el: '.pdp__info__upsells__content__pagination',
        type: 'bullets',
      },
    })
  },
  BuildYourRoutineSection = () => {
    new Swiper(selectors.buildYourRoutineSlider, {
      slidesPerView: 2.1,
      spaceBetween: 4,
      centeredSlides: !0,
      loop: !0,
      breakpoints: {
        768: {
          spaceBetween: 16,
          slidesPerView: 3,
          centeredSlides: !1,
          threshold: 32,
          navigation: {
            nextEl: '.pdp__build-your-routine__content__next',
            prevEl: '.pdp__build-your-routine__content__prev',
          },
        },
        1024: {
          spaceBetween: 16,
          slidesPerView: 4,
          centeredSlides: !1,
          threshold: 32,
          navigation: {
            nextEl: '.pdp__build-your-routine__content__next',
            prevEl: '.pdp__build-your-routine__content__prev',
          },
        },
      },
    })
  },
  TipsAndTricksSection = () => {
    const initializeYouTubePlayers = () => {
      document.querySelectorAll('.yt-player[data-plyr-provider="youtube"]').forEach((element) => {
        if (element.dataset.fbmPlayerInitialized === 'true') return

        try {
          const player = new Plyr(element)
          const labelBufferedProgress = () => {
            const container = player.elements && player.elements.container
            const buffer = container && container.querySelector('.plyr__progress__buffer')
            if (buffer && !buffer.getAttribute('aria-label')) {
              buffer.setAttribute('aria-label', 'Video buffered')
            }
          }
          labelBufferedProgress()
          player.on('ready', labelBufferedProgress)
          window.FBMPrivacyGate.registerPlayer(element, player, () => {
            if (player && typeof player.destroy === 'function') player.destroy()
          })
        } catch (error) {
          console.error('Unable to initialize a consent-approved product video.', error)
        }
      })
    }

    if (window.FBMPrivacyGate) {
      window.FBMPrivacyGate.onChange((consentAllowed) => {
        if (consentAllowed) initializeYouTubePlayers()
      })
    }

    new Swiper(selectors.tipsAndTricksSlider, {
      slidesPerView: 1,
      spaceBetween: 0,
      autoHeight: !0,
      pagination: {
        el: '.pdp__tips-tricks__content__pagination',
        type: 'bullets',
      },
      navigation: {
        nextEl: '.pdp__tips-tricks__content__next',
        prevEl: '.pdp__tips-tricks__content__prev',
      },
    })
  },
  SimilarProductsSection = () => {
    if (!document.querySelector(selectors.similarProductsSlider)) return
    const e = document
      .querySelector(selectors.similarProductsSlider)
      .querySelectorAll('.swiper-slide')
    !(function () {
      let t
      ;(t =
        2 === e.count
          ? {
              slidesPerView: 1.1,
              spaceBetween: 8,
              centeredSlides: !0,
              pagination: {
                el: '.pdp__similar-products__content__pagination',
                type: 'bullets',
              },
              breakpoints: {
                576: {
                  spaceBetween: 8,
                  slidesPerView: 2,
                  centeredSlides: !1,
                },
              },
            }
          : {
              slidesPerView: 1.1,
              spaceBetween: 8,
              centeredSlides: !0,
              pagination: {
                el: '.pdp__similar-products__content__pagination',
                type: 'bullets',
              },
              breakpoints: {
                576: {
                  spaceBetween: 8,
                  slidesPerView: 2,
                  centeredSlides: !1,
                },
                864: {
                  spaceBetween: 16,
                  slidesPerView: 3,
                  centeredSlides: !1,
                },
              },
            }),
        new Swiper(selectors.similarProductsSlider, t)
    })()
  },
  UpsellProduct = () => {
    let e = JSON.parse(localStorage.getItem('bundlePopups'))
        ? JSON.parse(localStorage.getItem('bundlePopups'))
        : [],
      t = $('.atcButton').data('product-id')
    t &&
      (e.includes(t || '')
        ? $('.upsellPopup').css('display', 'none')
        : $('.upsellPopup').css('display', 'flex'),
      $('.atcButton').on('click', (e) => {
        let i = {
          items: [
            {
              quantity: 1,
              id: e.target.dataset.bundleId,
            },
          ],
        }
        jQuery.post('/cart/add.js', i).done(function () {
          window.rfd.renderCart(!1, window.rfd.enableBtns)
          var e = JSON.parse(localStorage.getItem('bundlePopups'))
            ? JSON.parse(localStorage.getItem('bundlePopups'))
            : []
          e.push(t),
            localStorage.setItem('bundlePopups', JSON.stringify(e)),
            $('.upsellPopup').remove()
        })
      }),
      $('.closeUpsellPopup').on('click', (e) => {
        $('.upsellPopup').remove()
        var i = JSON.parse(localStorage.getItem('bundlePopups'))
          ? JSON.parse(localStorage.getItem('bundlePopups'))
          : []
        i.push(t), localStorage.setItem('bundlePopups', JSON.stringify(i))
      }),
      requestAnimationFrame(() => {
        $('.upsellPopup').addClass('slideIn')
      }))
  },
  UniqueQuickInputs = () => {
    const e = document.querySelectorAll('[data-quick-add-variant-input]'),
      t = document.querySelectorAll('[data-quick-add-variant-label]')
    if (e.length && t.length)
      for (let i = 0; i < e.length; i++) {
        let n = Math.floor(Date.now() + 1e3 * Math.random())
        ;(e[i].id = e[i].id + '-' + n), (t[i].htmlFor = t[i].htmlFor + '-' + n)
      }
  },
  ThumbnailKeyboardNavigation = () => {
    const thumbnailButtons = document.querySelectorAll(selectors.thumbnailItem)

    thumbnailButtons.forEach((button, index) => {
      button.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          // Trigger the same action as clicking the thumbnail
          thumbnailsSlider.slideTo(index)
          mainSlider.slideTo(index)
        }
      })
    })
  }

document.addEventListener('DOMContentLoaded', function () {
  ProductPrice()
  ProductImagesSection()
  ThumbnailKeyboardNavigation()
  ProductInfoUpsells()
  BuildYourRoutineSection()
  TipsAndTricksSection()
  SimilarProductsSection()
  UpsellProduct()
  UniqueQuickInputs()
})
//# sourceMappingURL=pdp.js.map
